import {ReportType} from "@mytour/shared";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {reportApiService} from "./reportApi.service";

/**
 * Keys store for transport queries.
 * A key is used to store data in the cache and invalidate it when necessary.
 */
export const keysStore = {
  root: ["reports"] as const,
  reports: (serviceTargetId: string) => [...keysStore.root, serviceTargetId] as const,
  list: (reportType: ReportType) => [...keysStore.root, reportType] as const,
  listAll: (reportType: ReportType) => [...keysStore.root, reportType, "all"] as const,
};

export function useReportsFor(serviceTargetId: string) {
  return useQuery({
    queryKey: keysStore.reports(serviceTargetId),
    queryFn: () => reportApiService.reportsFor(serviceTargetId),
    refetchOnWindowFocus: false,
  });
}

export function useBulkUpdateMetadata() {
  const queryClient = useQueryClient();
  const {mutateAsync} = useMutation({
    mutationFn: reportApiService.bulkUpdateMetadata,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: keysStore.list(ReportType.SPECTRUM),
      });
    },
  });
  return mutateAsync;
}

export function useListMetadata(reportType: ReportType) {
  return useQuery({
    queryKey: keysStore.list(reportType),
    queryFn: reportApiService.fetch5Recommandations,
    refetchOnWindowFocus: false,
  });
}
export function useListAllMetadata(reportType: ReportType) {
  return useQuery({
    queryKey: keysStore.listAll(reportType),
    queryFn: reportApiService.allRecommandations,
    refetchOnWindowFocus: false,
  });
}
